import React from "react";
import PageBanner from "../PageBanner/PageBanner";
import { FREE_LIBRARY_NOTES_BANNER } from "../../constants/text_constants";
import BANNER_IMG from "../../assets/GirlWithLaptop.png";
import BACKGROUND_IMAGE from "../../assets/BgOverlayImage.jpeg";
import PDFIcon from "../../assets/PDF_ICON_2.png";

const FreeLibraryNotes = () => {
  return (
    <div className="overflow-hidden">
      {/* ================= PAGE BANNER ================= */}
      {/* <PageBanner
        title={FREE_LIBRARY_NOTES_BANNER?.title1}
        subtitle={FREE_LIBRARY_NOTES_BANNER?.subtitle}
        rightImgSrc={BANNER_IMG}
        backgroundGradient={
          "linear-gradient(to right, rgba(254, 246, 250, 0.9) 45%, rgba(102, 269, 244, 0.8))"
        }
        backgroundImage={BACKGROUND_IMAGE}
        fontColor={"#130C40"}
      /> */}

      {/* ================= COMING SOON ================= */}
      <section className="lg:mx-[10rem] md:mx-[3rem] mx-[1rem] mt-10 mb-20">
        <div
          className="
            relative
            overflow-hidden
            rounded-[2rem]
            border
            border-[#E8DCEF]
            bg-gradient-to-br
            from-[#FFF8FC]
            via-white
            to-[#F5F0FA]
            px-5
            py-14
            md:px-10
            md:py-16
            lg:px-16
            lg:py-20
            text-center
            shadow-sm
          "
        >
          {/* Decorative Background */}
          <div
            className="
              absolute
              -top-24
              -right-24
              h-64
              w-64
              rounded-full
              bg-[#5A277C]/10
              blur-3xl
            "
          />

          <div
            className="
              absolute
              -bottom-28
              -left-24
              h-72
              w-72
              rounded-full
              bg-[#F3A6C8]/20
              blur-3xl
            "
          />

          {/* Floating Decorative Dots */}
          <div className="absolute top-10 left-[10%] w-3 h-3 rounded-full bg-[#5A277C]/20" />
          <div className="absolute top-20 right-[15%] w-4 h-4 rounded-full bg-[#F3A6C8]/30" />
          <div className="absolute bottom-16 right-[10%] w-3 h-3 rounded-full bg-[#5A277C]/20" />

          {/* Badge */}
          <div className="relative flex justify-center mb-7">
            <div
              className="
                inline-flex
                items-center
                gap-2
                rounded-full
                border
                border-[#5A277C]/20
                bg-white
                px-5
                py-2.5
                shadow-sm
              "
            >
              <span className="relative flex h-2.5 w-2.5">
                <span
                  className="
                    absolute
                    inline-flex
                    h-full
                    w-full
                    animate-ping
                    rounded-full
                    bg-[#F3A6C8]
                    opacity-75
                  "
                />

                <span
                  className="
                    relative
                    inline-flex
                    h-2.5
                    w-2.5
                    rounded-full
                    bg-[#5A277C]
                  "
                />
              </span>

              <span
                className="
                  text-xs
                  md:text-sm
                  font-bold
                  tracking-wider
                  text-[#5A277C]
                "
              >
                SOMETHING GREAT IS COMING
              </span>
            </div>
          </div>

          {/* Icon */}
          <div className="relative flex justify-center mb-7">
            <div
              className="
                flex
                items-center
                justify-center
                w-24
                h-24
                md:w-28
                md:h-28
                rounded-[2rem]
                bg-gradient-to-br
                from-[#5A277C]
                to-[#7B3FA3]
                shadow-xl
                shadow-[#5A277C]/20
                rotate-[-4deg]
              "
            >
              <img
                src={PDFIcon}
                alt="Rankplus Study Library"
                className="
                  w-12
                  h-12
                  md:w-14
                  md:h-14
                  brightness-0
                  invert
                  opacity-95
                "
              />
            </div>
          </div>

          {/* Main Heading */}
          <div className="relative">
            <h2
              className="
                text-3xl
                md:text-4xl
                lg:text-5xl
                font-extrabold
                text-[#130C40]
                leading-tight
              "
            >
              A Better Way to
              <span className="block text-[#5A277C] mt-2">
                Prepare Is Coming.
              </span>
            </h2>

            <p
              className="
                max-w-2xl
                mx-auto
                mt-6
                text-sm
                md:text-base
                lg:text-lg
                leading-7
                text-gray-600
              "
            >
              We are building something special for
              paramedical students — a powerful collection of
              study resources designed to make your exam
              preparation simpler, smarter and more effective.
            </p>
          </div>

          {/* Feature Cards */}
          <div
            className="
              relative
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-4
              gap-3
              max-w-4xl
              mx-auto
              mt-10
            "
          >
            {[
              {
                icon: "📚",
                title: "Study Notes",
                text: "Focused learning material",
              },
              {
                icon: "📝",
                title: "Practice",
                text: "Exam-oriented questions",
              },
              {
                icon: "🎯",
                title: "Exam Focused",
                text: "Built around your goals",
              },
              {
                icon: "🧪",
                title: "Paramedical",
                text: "Made for your field",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="
                  bg-white
                  rounded-2xl
                  border
                  border-[#EDE5F1]
                  px-4
                  py-5
                  shadow-sm
                  transition-all
                  duration-300
                  hover:-translate-y-1
                  hover:shadow-md
                "
              >
                <div className="text-2xl mb-2">
                  {item.icon}
                </div>

                <h3 className="text-sm font-bold text-[#130C40]">
                  {item.title}
                </h3>

                <p className="text-xs text-gray-500 mt-1">
                  {item.text}
                </p>
              </div>
            ))}
          </div>

          {/* Bottom Message */}
          <div className="relative mt-10">
            <div
              className="
                inline-flex
                flex-col
                md:flex-row
                items-center
                gap-1
                md:gap-2
                rounded-2xl
                bg-[#130C40]
                px-6
                py-3.5
                shadow-lg
              "
            >
              <span className="text-white text-sm font-semibold">
                Keep learning.
              </span>

              <span className="hidden md:block text-[#F3A6C8]">
                •
              </span>

              <span className="text-[#F3A6C8] text-sm font-bold">
                Keep preparing. Keep ranking.
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FreeLibraryNotes;
// import React, { useState, useEffect } from "react";
// import PageBanner from "../PageBanner/PageBanner";
// import { FREE_LIBRARY_NOTES_BANNER } from "../../constants/text_constants";
// import BANNER_IMG from "../../assets/GirlWithLaptop.png";
// import BACKGROUND_IMAGE from "../../assets/BgOverlayImage.jpeg";
// import TabHeadings from "./TabHeadings";
// import { useDispatch, useSelector } from "react-redux";
// import { setFreeLibraryNotesCache } from "../../configs/cache";
// import LoadingLottie from "../Lottie-Components/LoadingLottie";
// import PDFIcon from "../../assets/PDF_ICON_2.png";
// import { Card, CardContent } from "../../components/ui/card";
// import { useNavigate,useLocation } from "react-router-dom";
// import userLogout from "../../utils/userLogout";
// import useAutoLogout from "../../utils/useAutoLogout";
// import { modExp } from "../../utils/util-functions/cryptoUtils";
// import PDFDialogButton from "../PDF-View-Component/PDFDialogButton";
// import DecodePdfUrl from "../../utils/util-functions/DecryptionUtil";
// import IntegratedPagination from "../Pagination/IntegratedPagination";
// import { decryptUrl } from "../../utils/util-functions/cryptoUtils";

// const FreeLibraryNotes = () => {
//   const [libraryNotesData, setLibraryNotesData] = useState(null);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const dispatch = useDispatch();
//   const cache = useSelector((store) => store.cache.freeLibraryNotesCache);
//   const navigate = useNavigate();
//   const handleLogout = () => userLogout(navigate, dispatch);
//   useAutoLogout(handleLogout);
//   const [encryptionData, setEncryptionData] = useState(null);
//   const location = useLocation();

//   const setPubPvtKey = () => {
//     const prime = 23;
//     const base = 5;

//     const clientPrivateKey = Math.floor(Math.random() * 100);
//     const clientPublicKey = modExp(base, clientPrivateKey, prime);

//     const cryptoData = {
//       clientPrivateKey: clientPrivateKey,
//       clientPublicKey: clientPublicKey,
//       prime: prime,
//     };

//     setEncryptionData(cryptoData);
//   };

//   const fetchFreeLibraryNotes = async (retries = 6) => {
//     try {
//       const response = await fetch(
//         process.env.REACT_APP_RANK_PLUS_FREE_LIBRARY_NOTES +
//           currentPage +
//           `/?publicKey=${encryptionData?.clientPublicKey}`
//       );
//       if (!response.ok) {
//         if (response.status >= 400 && response.status < 500) {
//           userLogout(navigate, dispatch, true);
//         }
//         if (response.status >= 500 && response.status < 600 && retries > 0) {
//           console.warn(`Retrying... attempts left: ${retries}`);
//           setTimeout(() => fetchFreeLibraryNotes(retries - 1), 10000);
//           return;
//         } else {
//           throw new Error(`HTTP error: ${response.status}`);
//         }
//       }
//       const json = await response.json();
//       setTotalPages(Math.ceil(json?.data?.total / parseInt(json?.data?.limit)));
//       setLibraryNotesData(json?.data);
//       dispatch(setFreeLibraryNotesCache([json?.data, currentPage]));
//     } catch (err) {
//       console.error("Error fetchFreeLibraryNotes", err);
//     }
//   };

//   useEffect(() => {
//     // if (cache[currentPage]) {
//     //   setLibraryNotesData(cache[currentPage]);
//     //   setTotalPages(Math.ceil(cache[currentPage]?.total / 12));
//     // } else if(encryptionData){
      
//     // }
//     fetchFreeLibraryNotes();
//   }, [encryptionData, currentPage]);

//   useEffect(() => setPubPvtKey(), []);

//   return (
//     <div className="overflow-hidden">
//       <PageBanner
//         title={FREE_LIBRARY_NOTES_BANNER?.title1}
//         subtitle={FREE_LIBRARY_NOTES_BANNER?.subtitle}
//         rightImgSrc={BANNER_IMG}
//         backgroundGradient={
//           "linear-gradient(to right, rgba(254, 246, 250, 0.9) 45%, rgba(102, 269, 244, 0.8))"
//         }
//         backgroundImage={BACKGROUND_IMAGE}
//         fontColor={"#130C40"}
//       />
//       <div className="lg:mx-[10rem] md:mx-[3rem] mx-[1rem]">
//         <TabHeadings
//           index={1}
//           text={"Total Notes"}
//           total={libraryNotesData?.total}
//         />
//       </div>
//       <div>
//         {(!libraryNotesData || libraryNotesData?.notes?.length === 0) && (
//           <LoadingLottie />
//         )}
//       </div>
//       <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:mx-[10rem] md:mx-[3rem] mx-[1rem] lg:gap-8 gap-4 mt-10">
//         {libraryNotesData?.notes.map((ele, i) => (
//           <div key={i}>
//             <Card className="rounded-2xl">
//               <CardContent style={{ fontFamily: "DM Sans" }} className="p-4">
//                 <div className="flex lg:gap-2 gap-2 items-center">
//   {/* Left: Icon */}
//   <div>
//     <img
//       alt={ele?.title}
//       src={PDFIcon}
//       className=" w-[1.5rem] h-[1.5rem]
//   md:w-[2.5rem] md:h-[2.5rem]
//   lg:w-[3rem] lg:h-[3rem]
//   opacity-80"
//       loading="lazy"
//     />
//   </div>

//   {/* Right: Title + Button in same row */}
//   <div className="flex flex-row items-center justify-between gap-2 w-full">
//     <div className="lg:text-[14px] text-[14px] font-bold">{ele?.title}</div>
//     <PDFDialogButton
//       BtnStyle={
//         "border-2 border-[#5A277C] lg:px-2 lg:py-1 px-1 py-0.3 rounded-xl hover:bg-[#5A277C]"
//       }
//       BtnText={"View"}
//       BtnTextStyle={"text-[#5A277C] hover:text-white"}
//       pdfUrl={DecodePdfUrl(
//         libraryNotesData,
//         ele?.note_pdf,
//         encryptionData
//       )}
//       DownloadFileName={ele?.title}
//       showIcon={false}
//       DownloadIcon={""}
//       ShowBtnText={true}
//     />
//   </div>
// </div>

//               </CardContent>
//             </Card>
//           </div>
//         ))}
//       </div>
//       <div className="mt-[3rem] mb-[7rem]">
//         <IntegratedPagination
//           currentPage={currentPage + 1}
//           totalPages={totalPages}
//           setCurrentPage={(page) => setCurrentPage(page - 1)}
//         />
//       </div>
//     </div>
//   );
// };

// export default FreeLibraryNotes;
